import React from 'react';

import { Typography } from '@mui/material';

/** Shared heading for the sections inside an account card. */
export default function SectionLabel({ children }: { children: React.ReactNode }) {
  return (
    <Typography variant="overline" color="text.secondary" sx={{ letterSpacing: 1 }}>
      {children}
    </Typography>
  );
}
